import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
export function Messages() {
  useScreenInit();
  return <div className="flex flex-col items-center justify-center min-h-[80vh] p-6 text-center" data-id="element-313">
      <div className="w-20 h-20 bg-brand-accent/10 rounded-full flex items-center justify-center mb-6" data-id="element-314">
        <MessageSquare className="w-10 h-10 text-brand-accent" data-id="element-315" />
      </div>
      <h1 className="text-2xl font-bold text-text-primary mb-2" data-id="element-316">Messages</h1>
      <p className="text-text-secondary max-w-xs" data-id="element-317">
        Chat with your mentor, sponsors, and other beneficiaries. Coming soon!
      </p>
    </div>;
}